<mhe-checkbox
  id="quick-annotation"
  data-testid="quick-annotation"
  data-automation-id="quick-annotation"
  [checked]="quickAnnotationEnabled$ | async"
  (change)="toggleQuickAnnotation()"
  >
  {{ "context.quick_annotation" | translate }}
</mhe-checkbox>

<div class="popover-wrapper">
  <button
    data-automation-id="quick-annotation-info-button"
    rdrxHideOnEscape
    #infoBtn
    type="button"
    class="quick-annotation-info"
    [attr.aria-expanded]="isPopoverOpen"
    (click)="togglePopover($event)"
    (keydown.escape)="onCloseKeydown($event)"
    (keydown.arrowDown)="togglePopover($event)"
    (keydown.arrowUp)="togglePopover($event)"
    (keydown.tab)="onCloseKeydown($event)"
    (keydown.shift.tab)="onCloseKeydown($event)"
    [mheTooltip]="'context.information' | translate"
    >
    <i class="dpg-icon dpg-icon-system-alert-info"></i>
  </button>

  @if (isPopoverOpen) {
    <div
      class="quick-annotation-popover"
      aria-label="quick annotation"
      (keydown.escape)="onCloseKeydown($event)"
      (keydown.tab)="onCloseKeydown($event)"
      >
      <div class="arrow"></div>
      <div class="content">
        <p tabindex="0" id="quick-annotation-description">{{ "context.quick_annotation_info" | translate }}</p>
      </div>
    </div>
  }
</div>
